export const EventCodes = Object.freeze({
  Uc_Wd_Ad_Click: 'Uc_Wd_Ad_Click' // 取款頁廣告位點擊
})

/** *
 * UMeng SDK related functions
 ***/
export function umengRecord(eventCode, eventParams) {
  const { aplus_queue } = window

  aplus_queue.push({
    action: 'aplus.record',
    arguments: [eventCode, 'CLK', eventParams]
  })
}

/** *
 * Event param utility functions
 ***/
export function getPredurationStr(initialTimestamp) {
  return `${initialTimestamp ? Date.now() - initialTimestamp : -1}`
}

export function minTwoDigits(number) {
  return number < 10 ? `0${number}` : number
}

export function getTimestampStr() {
  const fullYear = `${new Date().getFullYear()}`
  const month = minTwoDigits(new Date().getMonth() + 1) // January starts from 0
  const day = minTwoDigits(new Date().getDate())
  const hours = minTwoDigits(new Date().getHours())
  const minutes = minTwoDigits(new Date().getMinutes())
  const seconds = minTwoDigits(new Date().getSeconds())

  return `${fullYear}/${month}/${day} ${hours}:${minutes}:${seconds}`
}
